(() => {
  const product = {
    fallbackUrl: '/products/electro-gum-stay-copy',
    sellingPlanId: 5336596732,
    plans: {
      '90': {
        variantId: 48846297268476,
        ctaLabel: 'Add to cart, $75 due today'
      },
      '30': {
        variantId: 48846297202940,
        ctaLabel: 'Add to cart, $29 due today'
      },
      one: {
        variantId: 48846297202940,
        ctaLabel: 'Add to cart, one-time purchase $40 due today'
      }
    }
  };

  const links = [
    ['Home', '/'],
    ['Shop', '/shop'],
    ['Science', '/science'],
    ['Ambassadors', '/ambassadors']
  ];

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function initMobileNav(root) {
    const header = root.querySelector('header');
    const toggle = root.querySelector('[data-electro-menu-toggle]');
    if (!header || !toggle) return;

    let nav = root.querySelector('.electro-export-mobile-nav');
    if (!nav) {
      const page = root.dataset.electroExportPage || 'home';
      nav = document.createElement('nav');
      nav.className = 'electro-export-mobile-nav md:hidden hidden bg-white';
      nav.setAttribute('aria-label', 'Mobile primary');
      nav.innerHTML = links.map(([label, href]) => {
        const active = (page === 'home' && label === 'Home') || page === label.toLowerCase();
        return '<a href="' + href + '"' + (active ? ' aria-current="page"' : '') + '>' + label + '</a>';
      }).join('');
      header.insertAdjacentElement('afterend', nav);
    }

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('hidden', open);
      toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    });
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartSections() {
    return ['cart-drawer'];
  }

  function openCartDrawer(trigger) {
    const drawer = getCartDrawer();
    if (!drawer || typeof drawer.open !== 'function') return false;

    drawer.open(trigger);
    return true;
  }

  function renderCartDrawer(parsedState, trigger) {
    const drawer = getCartDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function' || !parsedState.sections) return false;
    if (!parsedState.sections['cart-drawer']) return false;

    if (typeof drawer.setActiveElement === 'function' && trigger) {
      drawer.setActiveElement(trigger);
    }
    drawer.classList.remove('is-empty');
    drawer.renderContents(parsedState);
    return true;
  }

  async function refreshCartDrawer(trigger) {
    const drawer = getCartDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function') return false;

    const url = window.location.pathname + '?sections=' + encodeURIComponent(getCartSections().join(','));
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) return false;

    const sections = await response.json();
    return renderCartDrawer({ sections }, trigger);
  }

  function updateCartBadges(root, count) {
    const safeCount = Number.isFinite(count) ? count : 0;
    const label = 'Open cart, ' + safeCount + ' ' + (safeCount === 1 ? 'item' : 'items');

    root.querySelectorAll('[data-electro-cart-trigger]').forEach((button) => {
      button.setAttribute('aria-label', label);
      const badge = Array.from(button.querySelectorAll('span[aria-hidden="true"]')).find((element) => {
        return element.classList.contains('rounded-full');
      });
      if (badge) badge.textContent = String(safeCount);
    });
  }

  function getCurrentCartCount(root) {
    const trigger = root.querySelector('[data-electro-cart-trigger]');
    const badge = trigger ? Array.from(trigger.querySelectorAll('span[aria-hidden="true"]')).find((element) => {
      return element.classList.contains('rounded-full');
    }) : null;
    const count = badge ? parseInt(badge.textContent || '0', 10) : 0;
    return Number.isFinite(count) ? count : 0;
  }

  async function syncCartCount(root) {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;

    const cart = await response.json();
    updateCartBadges(root, cart.item_count || 0);
  }

  function initCart(root) {
    const activeCardClasses = ['border-electro-orange', 'bg-electro-cream'];
    const inactiveCardClasses = ['border-gray-200', 'bg-white', 'hover:border-gray-300'];
    const activeOneTimeClasses = ['text-electro-orange', 'font-bold'];
    const inactiveOneTimeClasses = ['text-gray-500', 'hover:text-electro-ink'];

    const planButtons = Array.from(root.querySelectorAll('button[aria-label^="Select "]'));
    const oneTimeButton = Array.from(root.querySelectorAll('button')).find((button) => {
      return /One-time purchase/i.test(button.textContent || '');
    });
    const addButtons = Array.from(root.querySelectorAll('[data-electro-add-to-cart]'));

    function getPlanFromButton(button) {
      const label = button.getAttribute('aria-label') || '';
      return label.includes('90-Day') ? '90' : '30';
    }

    function setClasses(element, removeClasses, addClasses) {
      element.classList.remove(...removeClasses);
      element.classList.add(...addClasses);
    }

    function getIndicator(button) {
      return Array.from(button.querySelectorAll('span[aria-hidden="true"]')).find((element) => {
        return element.classList.contains('w-5') && element.classList.contains('h-5');
      });
    }

    function setPlanButtonState(button, isActive) {
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      setClasses(
        button,
        isActive ? inactiveCardClasses : activeCardClasses,
        isActive ? activeCardClasses : inactiveCardClasses
      );

      const indicator = getIndicator(button);
      if (!indicator) return;

      setClasses(
        indicator,
        isActive ? ['border-gray-300'] : ['border-electro-orange'],
        isActive ? ['border-electro-orange'] : ['border-gray-300']
      );

      const dot = indicator.querySelector('[data-electro-plan-dot]') || Array.from(indicator.children).find((element) => {
        return element.classList.contains('w-2.5') && element.classList.contains('h-2.5');
      });
      if (isActive && !dot) {
        const activeDot = document.createElement('span');
        activeDot.className = 'w-2.5 h-2.5 rounded-full bg-electro-orange';
        activeDot.setAttribute('data-electro-plan-dot', 'true');
        indicator.appendChild(activeDot);
      } else if (isActive && dot) {
        dot.setAttribute('data-electro-plan-dot', 'true');
      } else if (!isActive && dot) {
        dot.remove();
      }
    }

    function setOneTimeState(isActive) {
      if (!oneTimeButton) return;
      oneTimeButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      setClasses(
        oneTimeButton,
        isActive ? inactiveOneTimeClasses : activeOneTimeClasses,
        isActive ? activeOneTimeClasses : inactiveOneTimeClasses
      );
    }

    function syncPlanSelection(plan) {
      const selectedPlan = product.plans[plan] ? plan : '90';
      root.dataset.electroPlan = selectedPlan;

      planButtons.forEach((button) => {
        setPlanButtonState(button, getPlanFromButton(button) === selectedPlan);
      });
      setOneTimeState(selectedPlan === 'one');

      const planConfig = product.plans[selectedPlan] || product.plans['90'];
      addButtons.forEach((button) => {
        button.setAttribute('aria-label', planConfig.ctaLabel);
      });
    }

    root.querySelectorAll('[data-electro-cart-trigger]').forEach((button) => {
      button.addEventListener('click', async () => {
	        if (openCartDrawer(button)) {
	          return;
	        }

        window.location.href = '/cart';
      });
    });

    syncPlanSelection(root.dataset.electroPlan || '90');

    planButtons.forEach((button) => {
      button.addEventListener('click', () => {
        syncPlanSelection(getPlanFromButton(button));
      });
    });

    if (oneTimeButton) {
      oneTimeButton.addEventListener('click', () => {
        syncPlanSelection('one');
      });
    }

    addButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const plan = root.dataset.electroPlan || '90';
        const planConfig = product.plans[plan] || product.plans['90'];
        const item = {
          id: planConfig.variantId,
          quantity: 1
        };
        if (plan !== 'one') item.selling_plan = product.sellingPlanId;

        const original = button.innerHTML;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.innerHTML = 'Adding...';
        try {
          const requestBody = { items: [item] };

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(requestBody)
          });
          if (!response.ok) throw new Error('cart add failed');
          button.innerHTML = 'Going to checkout...';

          if (window.ElectroCheckoutRedirect?.goToCheckout) {
            window.ElectroCheckoutRedirect.goToCheckout();
          } else {
            window.location.href = '/checkout';
          }
        } catch (_error) {
          if (!openCartDrawer(button)) window.location.href = product.fallbackUrl;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = original;
        }
      });
    });
  }

  function initAccordions(root) {
    root.addEventListener('click', (event) => {
      const button = event.target.closest('button[aria-controls]');
      if (!button || !root.contains(button)) return;
      const id = button.getAttribute('aria-controls');
      if (!id) return;
      const panel = root.querySelector('#' + CSS.escape(id));
      if (!panel) return;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      panel.style.display = open ? 'none' : '';
    });
  }

  function initVideos(root) {
    const videos = Array.from(root.querySelectorAll('[data-electro-video="true"]'));
    if (!videos.length) return;

    const play = (video) => {
      video.muted = true;
      video.loop = true;
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(() => {});
    };
    const pause = (video) => {
      video.pause();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) play(entry.target);
          else pause(entry.target);
        });
      }, { threshold: 0.35 });
      videos.forEach((video) => observer.observe(video));
    } else {
      videos.forEach(play);
    }
  }

  function initRoot(root) {
    initMobileNav(root);
    initCart(root);
    initAccordions(root);
    initVideos(root);
  }

  onReady(() => {
    document.querySelectorAll('.electro-export-root').forEach(initRoot);
  });
})();
